<!--suppress JSUnresolvedVariable -->
<template>
  <div class="ticker-custom-chart-container ml-2">
    <h3>Create Chart</h3>

    <div class="col-sm-5 my-3 mb-4">
      <b-input v-model="chartName" placeholder="Enter Chart Name"/>
    </div>
    <div class="col-sm-5 mb-4 mt-0 pt-0">
      <tag-autocomplete
        v-on:tagSelected="selectTagForChart"
      ></tag-autocomplete>
    </div>

    <!-- Selected Tags container  -->
    <div class="ticker-tag-selected-list-container text-left my-3 mx-3"
         v-if="selectedTags != null && Object.keys(selectedTags).length > 0">
      <span v-for="(tags, tagSrc) in selectedTags" :key="tagSrc"
            class="ticker-tag-selected p-2 bg-light border border-dark rounded-sm mr-1"
      >
        {{tagSrc}}
        <span v-for="tag in tags" :key="tag.uuid">
          <span class="ticker-tag-selected p-1 m-1 bg-info border border-light rounded-pill"
                v-b-tooltip.hover title="Click to configure"
                v-on:click="showConfigureFieldDetails(tag)"
          >
             {{tag.name}}
          </span>
        </span>
      </span>
    </div>

    <div class="col-sm-5 my-3 mb-4">
      <b-input v-model="testTicker" placeholder="Enter Company Ticker to test Chart"/>
    </div>

    <div class="'action-buttons mx-3 text-left"
         v-if="selectedTags != null && Object.keys(selectedTags).length > 0">

      <b-button v-b-tooltip.hover title="Save Chart"
                size="sm"
                class="mr-2"
                v-on:click="saveChart">
        Save Chart
      </b-button>

      <b-button v-b-tooltip.hover title="Configure Y Axis"
                size="sm"
                class="mr-2"
                v-b-modal.configure-y-axis-modal >
        Configure Y Axis
      </b-button>

      <b-button v-b-tooltip.hover title="Run Chart"
                size="sm"
                v-on:click="runChart"
                v-if="testTicker !== undefined && testTicker !== ''"
      >Run Chart
      </b-button>

    </div>
    <configure-y-axis :available-tags="selectedTags"
                      v-on:customizeYAxisConfiguration="customizeYAxisConfiguration"/>

    <configure-field :field-details="configureFieldDetails"
                     v-on:configureField="configureField"
    ></configure-field>

    <div v-if="showChart">
      <line-chart
        :ticker-name="testTicker"
        :ticker="testTicker"
        :y-axis-configuration="yAxisConfiguration"
        :chart-details="chartDetails"
        :reload="reload"
      ></line-chart>
    </div>
  </div>
</template>

<!--suppress CssUnusedSymbol -->
<style>
  .ticker-company-details-tooltip.tooltip .tooltip-inner {
    max-width: 40rem !important;
    width: 40rem !important;
  }
</style>

<script>
/* eslint-disable */

  import apiCall from '@/assets/js/stockifyApi';
import {CHART_URL, TICKER_URL} from '@/assets/js/endpoints';
  import CandlestickChart from '@/charts/candlestick.vue';
  import TagAutocomplete from "@/charts/TagAutocomplete";
  import TickerDetails from "@/components/TickerDetails";
  import LineChart from "@/charts/linechart";
  import ConfigureYAxis from "@/components/Chart/ConfigureYAxis";
import ConfigureField from "@/components/Chart/ConfigureField";

  export default {
    name: 'CustomChartCreate',
    components: {
      ConfigureField,
      ConfigureYAxis,
      LineChart,
      TagAutocomplete,
      TickerDetails,
      CandlestickChart,
    },
    data() {
      return {
        dataResolution: null,
        dataFormat: null,
        chartResolutionOptions: [
          { text: 'Quarterly', value: 'Q' },
          { text: 'Quarterly (12 Months)', value: 'Q-12' },
          { text: 'Yearly', value: 'Y' },
          { text: 'Trailing 12 Months', value: 'TTM' },
        ],
        dataDisplayOptions: [
          { text: 'Absolute', value: 'A' },
          { text: 'Change %', value: 'C' },
        ],
        chartName: null,
        testTicker: this.$route.query.ticker,
        selectedTags: null,
        showChart: false,
        reload: 0,
        yAxisConfiguration: null,
        chartId: this.$route.params.id,
        configureFieldDetails: null,
        configureFieldValues: {},
        chartDetails: {
          chart_fields: [],
          yaxis: {}
        },
      };
    },
    methods: {
      loadTickerDetails(ticker) {
        apiCall({method: 'GET', url: `${TICKER_URL}/${ticker}`}).then((resp) => {
          // noinspection JSUnresolvedVariable
          this.tickerDetails = resp.data.ticker;
        });
      },
      tagSelected(selectedTags) {
        this.selectedTags = selectedTags;
      },
      selectTagForChart(tag) {
        if (tag === null) { return }

        this.chartDetails.chart_fields.push({tag_uuid: tag.uuid, tag_details: tag, src: tag.statement_code });

        const tagSrc = tag['statement_code']
        if (this.selectedTags === null) {
          this.selectedTags = {[tagSrc]: []};
          this.selectedTags[tagSrc].push(tag);
        } else if (tagSrc in this.selectedTags) {
          this.selectedTags[tagSrc].push(tag);
        } else {
          this.$set(this.selectedTags, [tagSrc], [tag]);
          // this.selectedTags.push({ [tagSrc]: [tag] });
        }
      },
      showConfigureFieldDetails(tag) {
        this.configureFieldDetails = tag
        this.$bvModal.show('configure-field-modal')
      },
      configureField(configureFieldValues) {
        this.chartDetails.chart_fields.forEach((chartField) => {
          const fieldDetails = configureFieldValues.fieldDetails;
          if (chartField.tag_uuid === configureFieldValues.uuid && fieldDetails !== undefined) {
            chartField.data_resolution = fieldDetails.dataResolution;
            chartField.data_format = fieldDetails.dataDisplayFormat;
          }
        })
      },
      runChart() {
        // only bump this if showChart is true. otherwise we'll get double fire for linechart load.
        if (this.showChart)
          this.reload++;

        this.showChart = true;
      },
      customizeYAxisConfiguration(yAxisConfig){
        this.yAxisConfiguration = yAxisConfig;
        this.chartDetails.yaxis = yAxisConfig;
        this.loadChart();
      },

      // TODO: Remove tag_details from chart details before submitting request.
      saveChart(){
        // console.log(this.chartDetails)
        this.chartDetails.name = this.chartName
        apiCall({
          method: 'POST',
          url: CHART_URL,
          data: {chart_details: this.chartDetails }
        })
      },
      loadChart(){
        if (this.chartId !== undefined && this.chartId !== ''){
          apiCall({
            method: 'GET',
            url: `${CHART_URL}/${this.chartId}`,
          }).then((response) => {
            this.yAxisConfiguration = response.data.yaxis;
            response.data.chart_fields.forEach((chart_field) => {

              if (chart_field !== null) {
                if (chart_field.calculated_field_details !== null) {
                  this.selectTagForChart(chart_field.calculated_field_details);
                }

                if (chart_field.datatag_details !== null) {
                  this.selectTagForChart(chart_field.datatag_details);
                }
              }
            });
            if (this.selectedTags !== null && this.yAxisConfiguration !== null) {
              this.runChart();
            }
          });
        }
      }
    },
    mounted() {
      this.loadChart();
    },
  };
</script>
